/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum OrderingCutoffStrategy {
  DAILY_CUTOFF = 'DAILY_CUTOFF',
  ALLOW_ON_THE_DAY_ORDERS = 'ALLOW_ON_THE_DAY_ORDERS',
  HOURS_BEFORE_START = 'HOURS_BEFORE_START',
}
